import React from 'react';
import { PortfolioData } from '../types/portfolio';

interface AboutProps {
  data: PortfolioData;
}

const About: React.FC<AboutProps> = ({ data }) => {
  const highlights = [
    'stakeholder engagement',
    'requirements gathering',
    'data-driven reporting',
    'Power BI',
    'Advanced Excel',
    'dashboard reporting',
    'Agile delivery',
    'MBA in Business Management',
  ];

  return (
    <section className="py-24 bg-ivory">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 items-start">
          {/* Heading Column */}
          <div className="lg:col-span-1">
            <h2 className="text-4xl font-manrope font-bold text-navy sticky top-24">
              {data.sections.about.heading}
            </h2>
            <div className="h-1 w-12 bg-teal mt-6 rounded-full"></div>
          </div>

          {/* Content Column */}
          <div className="lg:col-span-3">
            <p className="text-lg leading-relaxed text-slate mb-8">
              {data.sections.about.summary.split(' ').map((word, idx) => {
                const lowerWord = word.toLowerCase();
                const isHighlight = highlights.some(h => lowerWord.includes(h.toLowerCase()));

                if (isHighlight) {
                  return (
                    <span key={idx} className="font-semibold text-teal">
                      {word}{' '}
                    </span>
                  );
                }
                return <span key={idx}>{word} </span>;
              })}
            </p>

            {/* Key Points */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
              <div className="border-l-2 border-teal pl-6">
                <h3 className="font-manrope font-bold text-navy mb-2">Experience</h3>
                <p className="text-slate">3+ years at Kyndryl with deep expertise in business analysis and reporting solutions.</p>
              </div>
              <div className="border-l-2 border-gold pl-6">
                <h3 className="font-manrope font-bold text-navy mb-2">Technical Skills</h3>
                <p className="text-slate">Proficient in Power BI, SQL, Advanced Excel, data analysis, and Agile methodologies.</p>
              </div>
              <div className="border-l-2 border-teal pl-6">
                <h3 className="font-manrope font-bold text-navy mb-2">Learning</h3>
                <p className="text-slate">Currently pursuing an MBA in Business Management to expand strategic business acumen.</p>
              </div>
              <div className="border-l-2 border-gold pl-6">
                <h3 className="font-manrope font-bold text-navy mb-2">Impact Driven</h3>
                <p className="text-slate">Focused on translating business needs into measurable improvements and business outcomes.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
